import PaymentMethodSelector from 'components/PaymentData/PaymentMethodSelector/styled';

export default PaymentMethodSelector;
